import {wxConfigRegister, wxShareRegister} from '@/utils/wxapi.js'
// @ts-ignore
import customConfig from '/customConfig.js'
export const useWechatShareEffect = () => {
    console.log('分享',customConfig.shareConfig.option)
    wxConfigRegister()
    wxShareRegister(customConfig.shareConfig.option)
}
